import { Palette, Check } from "lucide-react";
import { THEMES, THEME_KEYS } from "./palette";

export const ThemePicker = ({ theme, onPick, label = "Calendar colour", testId = "calendar-theme",
                              note = "this page only" }) => (
  <div className="mt-5 flex flex-wrap items-center gap-3 rounded-2xl border border-white/10 bg-panel p-4"
       data-testid={`${testId}-picker`}>
    <p className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest"
       style={{ color: THEMES[theme]?.accent }}>
      <Palette className="h-3.5 w-3.5" /> {label}
    </p>
    <div className="flex flex-wrap gap-2">
      {THEME_KEYS.map((key) => (
        <button
          key={key}
          data-testid={`${testId}-${key}`}
          onClick={() => onPick(key)}
          aria-label={THEMES[key].label}
          title={THEMES[key].label}
          className="flex h-7 w-7 items-center justify-center rounded-full transition-transform hover:scale-110"
          style={{
            backgroundColor: THEMES[key].accent,
            boxShadow: theme === key ? `0 0 0 2px rgba(255,255,255,.85)` : "none",
            opacity: theme === key ? 1 : 0.75,
          }}
        >
          {theme === key && <Check className="h-3.5 w-3.5 text-page" />}
        </button>
      ))}
    </div>
    <p className="text-xs text-ink-soft">{THEMES[theme]?.label} — {note}.</p>
  </div>
);
